import React, { PureComponent } from "react";
import _ from "lodash";
import { branch } from 'baobab-react/higher-order';

import autoBind from "react-autobind";
import ReactCardFlip from 'react-card-flip';
import FontAweesome from "react-fontawesome";
import { Motion, spring } from 'react-motion';

import { hideAssociatedContentCard, increaseStage } from "../../actions/playerActions";
import { markdownToHtml } from "../../utils/markupUtils";

const cardWidth = 410;
const cardHeight = 600;
class RankItemAnimatedCard extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			stage: 0,
			width: 0,
			height: 0,
			fontSize: 0,
			opacity: 0,
			isFlipped:false
		}
		// this.card = React.createRef();
		this.firstCard = React.createRef();
		autoBind(this);
	}

	hide() {
		hideAssociatedContentCard();
	}

	flip() {
		this.card.flip();
	}

	handleClick() {
		this.setState({
			isFlipped: !this.state.isFlipped
		});
	}

	render() {

		const { associatedContent } = this.props;
		const { renderedAssociatedContent, label, targetStyles, targetTextStyles, stage, listIndex, sectionIndex, itemIndex } = associatedContent;

		if (associatedContent.show) {
			return (
				<div style={styles.container}>
					<div onClick={this.hide} style={styles.closeButton}>
						<FontAweesome name="times" style={{ fontSize: 20 }} />
					</div>
					<Motion defaultStyle={{ width: 0, height: 0, opacity: 0 }} style={{ width: spring(cardWidth), height: spring(cardHeight), opacity: spring(1) }} onRest={() => {increaseStage() }}>
						{interpolatingStyle =>
							<ReactCardFlip isFlipped={this.state.isFlipped} flipDirection="horizontal">
								<div style={_.assign({}, styles.cardContainer, { width: interpolatingStyle.width, height: interpolatingStyle.height, overflow: "hidden" })} key="front">
									<div onClick={() => { stage > 0 ? this.handleClick() : void (0); }} style={_.assign({}, styles.cardMain, targetStyles, { overflow: "hidden" })}>
										{stage >= 1 && <Motion defaultStyle={{ opacity: 0 }} style={{ opacity: spring(1) }} onRest={() => { increaseStage() }}>
											{interpolatingStyle2 =>
												<div style={_.assign({}, { opacity: interpolatingStyle2.opacity }, targetTextStyles)} dangerouslySetInnerHTML={markdownToHtml(label)} />
											}	
										</Motion>
										}
									</div>
								</div>
								{stage >= 3 && <div style={_.assign({}, styles.cardContainer, { width: interpolatingStyle.width, height: interpolatingStyle.height })} key="back">
									<div onClick={() => { stage > 0 ? this.handleClick() : void (0); }} style={_.assign({}, styles.cardMain, {
										width: "100%", height: "100%", overflow: "hidden",
										backgroundColor: 'white',padding:10 })}>
										<div className="associatedContentText" style={{ maxWidth: "100%", maxHeight: "100%", padding: 10, overflowY: "auto", borderRadius: 5 }} dangerouslySetInnerHTML={markdownToHtml(renderedAssociatedContent, { stopLinkEventPropagation: true, listIndex, sectionIndex, itemIndex})} />
									</div>
								</div>}
							</ReactCardFlip>
						}	
					</Motion>	
				</div>
					)	
		} else {
			return null;
		}
	}

	// componentDidMount() {
	// 	increaseStage();
	// }

	UNSAFE_componentWillReceiveProps(newProps, newState) {
		if (newProps.associatedContent.stage === 1 && this.props.associatedContent.stage !== 1) {
			// LayoutAnimation.spring();
			// this.setState({ width: this.state.width + 320, height: this.state.height + 470 });

			setTimeout(() => {
				increaseStage();
			}, 500);
		} else if (newProps.associatedContent.stage === 2 && this.props.associatedContent.stage !== 2) {
			// LayoutAnimation.spring();
			// this.setState({ opacity: 1 });
			setTimeout(() => {
				increaseStage();
			}, 1000);
		} else if (newProps.associatedContent.stage === 3 && this.props.associatedContent.stage !== 3) {
			this.setState({
				isFlipped: !this.state.isFlipped
			})
		}
	}

}

const styles = {
	container: {
		display: "flex",
		justifyContent: 'center',
		alignItems: 'center',
		position: "fixed", width: "100%", height: "100%", left: 0, top: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,.5)",zIndex:11
	},
	cardContainer: {
		width: cardWidth,
		height: cardHeight,
		position: "relative"
	},
	closeButton: {
		position: "absolute",
		top: 10,
		right: 10,
		backgroundColor: "white",
		width: 40,
		height: 40,
		borderRadius: 20,
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	card: {
		width: "100%",
		height: "100%",
		padding: 10,
		backgroundColor: 'white',
		borderRadius: 5,
		shadowColor: 'rgba(0,0,0,0.5)',
		shadowOffset: {
			width: 0,
			height: 1
		},
		shadowOpacity: 0.5
	},
	cardMain: {
		width: "100%",
		height: "100%",
		padding: 20,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		borderRadius: 5,
		overflow: "hidden",
		shadowColor: 'rgba(0,0,0,0.5)',
		shadowOffset: {
			width: 0,
			height: 1
		},
		shadowOpacity: 0.5,
	}
};

export default branch({
	associatedContent: ["associatedContentCard"]
}, RankItemAnimatedCard);